import { Component, Input, OnInit } from '@angular/core';
/**
  Componente que muestra una etiqueta (`label`) y un valor asociado.
  Este componente es útil para mostrar información en un formato de etiqueta-valor,
  con la opción de mostrar solo el valor si es necesario.
**/
@Component({
    selector: 'am-label',
    templateUrl: './am-label.component.html',
    styleUrls: ['./am-label.component.scss'],
    standalone: false
})
export class AmLabelComponent implements OnInit {

 /**
    Texto de la etiqueta que se mostrará junto al valor.
    @type {string}
    @default ''
  **/
    @Input() label: string = '';

    /**
      Valor que se mostrará junto a la etiqueta.
      @type {string}
      @default ''
    **/
    @Input() value: string = '';
  
    /**
      Indica si solo se debe mostrar el valor, sin la etiqueta.
      @type {boolean}
      @default false
    **/
    @Input() onlyValue: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
